<i18n>
{
  "fr": {
      "title": "Edition du formulaire Conformité",
      "titleForm": "Conformité - Dossier N°{folderNumber}",
      "submit": "Enregistrer",
      "submitForValidation": "Enregistrer pour validation",
      "cancel": "Retour",
      "processing": "Traitement en cours..."

  }
}
</i18n>

<template>
  <b-row :class="{noActive : isProcessing }" class="conformite">
    <div :class="{ 'no-data-message': isProcessing }" id="processing-message" class="message">
      <div class="content">
        <h4 class="align-center">
          <slot name="Loading">{{ this.$i18n.t('processing') }}</slot>
        </h4>
      </div>
    </div>
    <b-col :class="{ 'no-data': isProcessing }">
      <InfoBar :title="this.$i18n.t('title')" />
      <template v-if="this.control">
        <form id="conformite" name="dynamic-validation" @submit.prevent="">
          <span v-if="checkLoaded"></span>
          <ConformiteFields name="conformiteFields" :conformiteForm="conformiteForm"
            :title="this.$i18n.t('titleForm', { folderNumber: property.folderNumber})" />
          <b-row>
            <b-col cols="12" class="submit-form">
              <b-link class="btn s-btn-b btn-gray mg-r-10" @click="onCancel">{{ $t('cancel') }}</b-link>

              <b-button type="submit" class="btn btn-cta" v-on:click="handleSubmitEdit('save')">
                <b-spinner v-if="isProcessing" />
                {{ $t('submit') }}
              </b-button>
              <b-button :disabled="disableSubmitForValidation" type="submit" class="btn btn-cta ml-3 disp-msg"
                v-on:click="handleSubmitEdit('saveForValidation')">
                <b-spinner v-if="isProcessing" />
                <span>{{ $t('submitForValidation') }}</span>
              </b-button>
              <span v-if="dateOfVisitValidation" class="ndisp red">Date de visite non saisie</span>
            </b-col>
          </b-row>
        </form>
      </template>
    </b-col>
    <ajax-intercept @start="ajaxStart" @finish="ajaxFinish"></ajax-intercept>
  </b-row>
</template>

<script>
import ConformiteFields from '../../fields/ConformiteFields.vue';
import InfoBar from '../../properties/InfoBar';
import { TYPE_CONFORMITE } from '../../../constants/params';
import { mapState, mapActions } from 'vuex';
import ajaxIntercept from 'vue-ajax-intercept';

export default {
  name: 'EditConformite',
  components: {
    ConformiteFields,
    InfoBar,
    ajaxIntercept,
  },
  data: () => ({
    hover: false,
    isProcessing: false,
    submitType: 'save',
    ajaxInterceptorCounter: 0,
    dataLoaded: false,
  }),
  mounted () {
      this.updateForm();
  },
  computed: {
    ...mapState({
      property: state => state.refProperties.property,
      conformiteForm: state => state.conformite.conformiteForm,
      controlId: state => state.route.params.controlId,
      control: state => state.refControls.control,
    }),
    dateOfVisitValidation() {
      if (this.conformiteForm.dateOfVisit === null) {
        return true;
      }
      return false;
    },
    checkStatus() {
      if (["waitingForValidation", "validated", "generatedMail", "closed"].includes(this.control.currentStatus.status.id)) {
        return true;
      }
      return false;
    },
    disableSubmitForValidation() {
      if (this.checkStatus || this.dateOfVisitValidation) {
        return true;
      }
      return false;
    },
    checkLoaded() {
      if (this.dataLoaded) {
        return true;
      }
      var dropzoneComponent = null;
      var parentComponent = this.$children.find(x => x.$attrs.name === 'conformiteFields');
      if (parentComponent) {
        dropzoneComponent = parentComponent.$children.find(x => x.$attrs.name === 'filesDropzone');
      }
      if (!this.dataLoaded && this.control && dropzoneComponent) {
        this.updateForm();
        this.dataLoaded = true;
      }
      return this.dataLoaded;
    },
  },
  created() {
    this.setTypeForm();
    this.getRequestConformiteById();
    this.initNotif();
  },

  methods: {
    ...mapActions(['initConformiteForm', 'initNotif', 'getRequestConformiteById']),
    updateForm() {

      var parentComponent = this.$children.find(x => x.$attrs.name === 'conformiteFields');
      if (parentComponent) {
        var dropzoneComponent = parentComponent.$children.find(x => x.$attrs.name === 'filesDropzone');

        this.$store.dispatch('joinFilesToControlForm', {
          component: dropzoneComponent,
          form: this.conformiteForm,
          controlId: this.controlId,
        });
      }
      else {
        console.log('parentComponent for dropzoneComponent is not initialized');
      }

    },
    handleSubmitEdit(submitType) {
      if (submitType === 'saveForValidation') {
        if (!confirm('Vous ne pourrez plus modifier le formulaire après cette action !')) {
          return;
        }
        this.conformiteForm.forceStatusWaitingForValidation = true;
      } else {
        this.conformiteForm.forceStatusWaitingForValidation = false;
      }
      this.isProcessing = true;
      this.setFilesInForm();
      this.$store.dispatch('handleSubmitEdit');
    },
    setFilesInForm() {
      var parentComponent = this.$children.find(x => x.$attrs.name === 'conformiteFields');
      var dropzoneComponent = parentComponent.$children.find(x => x.$attrs.name === 'filesDropzone');
      this.$store.dispatch('setFilesInForm', { component: dropzoneComponent, form: this.conformiteForm });
    },
    setTypeForm() {
      this.$store.commit('setTypeForm', TYPE_CONFORMITE);
    },
    onCancel() {
      this.initConformiteForm();
      this.initNotif();
      this.$router.push({ name: `property_detail`, params: { propertyId: this.property.id } });
    },
    ajaxStart() {
      this.ajaxInterceptorCounter++;
      this.isProcessing = true;
    },
    ajaxFinish() {
      this.ajaxInterceptorCounter--;
      if (this.ajaxInterceptorCounter <= 0) {
        this.isProcessing = false;
      }
    },
  },
};
</script>
